import { render, staticRenderFns } from "./BeneficiaryForm.vue?vue&type=template&id=1d344c18&"
import script from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports